import { performLogout } from '@/src/context/AuthContext'
import { Country } from '@/src/types/apps/resto365Countries'
import axios from 'axios'
import { getOrRefreshAccessToken, sessionCountry } from './session'

const scheme = 'Bearer'
const httpClient = axios.create({ baseURL: 'httpClient' })
const gygInternalApiClient = axios.create({ baseURL: 'gygInternalApiClient' })
const gygExternalApiClient = axios.create({ baseURL: 'gygExternalApiClient' })

const authInterceptor = async (config: any) => {
  const token = await getOrRefreshAccessToken()
  config.headers.setAuthorization(`${scheme} ${token}`)

  return config
}

const baseURLInterceptor = (config: any) => {
  switch (sessionCountry) {
    case Country.USA:
      switch (config.baseURL) {
        case 'httpClient':
          config.baseURL = process.env.NEXT_PUBLIC_R365_API_US
          break
        case 'gygInternalApiClient':
          config.baseURL = process.env.NEXT_PUBLIC_BHYVE_INTERNAL_API_US
          break
        case 'gygExternalApiClient':
          config.baseURL = process.env.NEXT_PUBLIC_BHYVE_EXTERNAL_API_US
          break
      }
      break
    case Country.AUS:
    default:
      switch (config.baseURL) {
        case 'httpClient':
          config.baseURL = process.env.NEXT_PUBLIC_R365_API_AU
          break
        case 'gygInternalApiClient':
          config.baseURL = process.env.NEXT_PUBLIC_BHYVE_INTERNAL_API_AU
          break
        case 'gygExternalApiClient':
          config.baseURL = process.env.NEXT_PUBLIC_BHYVE_EXTERNAL_API_AU
          break
      }
      break
  }

  return config
}

httpClient.interceptors.request.use(authInterceptor)
httpClient.interceptors.request.use(baseURLInterceptor)
gygInternalApiClient.interceptors.request.use(baseURLInterceptor)
gygExternalApiClient.interceptors.request.use(baseURLInterceptor)

let logoutInProgress = false

const shouldLogoutOn401 = (url?: string): boolean => {
  if (!url) return true

  return !/\/(login|register)(\/|$|\?)/i.test(url)
}

httpClient.interceptors.response.use(
  response => {
    return response
  },
  async error => {
    const status = error?.response?.status
    const requestUrl = String(error?.config?.url ?? '')

    if (status === 401 && shouldLogoutOn401(requestUrl) && !logoutInProgress) {
      logoutInProgress = true
      try {
        await performLogout()
      } finally {
        logoutInProgress = false
      }
    }

    return Promise.reject(error)
  }
)

export { httpClient, gygInternalApiClient, gygExternalApiClient }
